import * as trace from 'owa-trace';
import { CampaignId } from '../schema/CampaignId';
import { getStore } from 'owa-lightning-core-v2/lib/store/store';
import { isMiniHostAppCampaignEnabled } from '../utils/isMiniHostAppCampaignEnabled';

const lightningToPromiseResolverMap: {
    [key: string]: (present: boolean) => void;
} = {};

let lightningStoreInitialized = false;

/**
 * Utility to check if a given lightning id is present in the lightning store.
 * @param idToCheck Lightning id to check
 */
export function isLightningIdPresent(idToCheck: string): boolean {
    return (
        isMiniHostAppCampaignEnabled(idToCheck as CampaignId) &&
        getStore().unseenItems &&
        !!getStore().unseenItems.get(idToCheck)
    );
}

export async function onLightningPresent(id: string): Promise<boolean> {
    if (lightningStoreInitialized) {
        return Promise.resolve(isLightningIdPresent(id));
    } else {
        // tslint:disable-next-line:promise-must-complete
        return new Promise(resolve => {
            lightningToPromiseResolverMap[id] = lightningToPromiseResolverMap[id] || null;
            lightningToPromiseResolverMap[id] = resolve;
        });
    }
}

export function resolveLightningPromises() {
    Object.keys(lightningToPromiseResolverMap).forEach(key => {
        try {
            lightningToPromiseResolverMap[key](isLightningIdPresent(key));
            delete lightningToPromiseResolverMap[key];
        } catch (error) {
            trace.errorThatWillCauseAlert('Error in resolving the promise.' + error.message);
        }
    });
    lightningStoreInitialized = true;
}
